import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=84c18dd8&scoped=true&"
import script from "./GridView.vue?vue&type=script&lang=ts&"
export * from "./GridView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c18dd8",
  null
  
)

export default component.exports